import { render, staticRenderFns } from "./DocumentPreviewModal.vue?vue&type=template&id=cb72db6e&scoped=true"
import script from "./DocumentPreviewModal.vue?vue&type=script&lang=js"
export * from "./DocumentPreviewModal.vue?vue&type=script&lang=js"
import style0 from "./DocumentPreviewModal.vue?vue&type=style&index=0&id=cb72db6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb72db6e",
  null
  
)

export default component.exports